import forestWaterfallImg from './assets/forest-waterfall.jpg';
import desertDunes from './assets/desert-dunes.jpg';
import majesticMountains from './assets/majestic-mountains.jpg';
import caribbeanBeachImg from './assets/caribbean-beach.jpg';
import ruinsImg from './assets/ruins.jpg';
import rainforestImg from './assets/rainforest.jpg';
import northernLightsImg from './assets/northern-lights.jpg';
import japaneseTempleImg from './assets/japanese-temple.jpg';
import greatBarrierReefImg from './assets/great-barrier-reef.jpg';
import parisianStreetsImg from './assets/parisian-streets.jpg';
import grandCanyonImg from './assets/grand-canyon.jpg';
import venetianCanalsImg from './assets/venetian-canals.jpg';
import tajMahalImg from './assets/taj-mahal.jpg';
import keralaBackwatersImg from './assets/kerala-backwaters.jpg';
import africanSavannaImg from './assets/african-savanna.jpg';
import victoriaFallsImg from './assets/victoria-falls.jpg';
import machuPicchuImg from './assets/machu-picchu.jpg';
import amazonRiverImg from './assets/amazon-river.jpg';

export const AVAILABLE_PLACES = [
  {
    id: 'p1',
    title: 'Forest Waterfall',
    image: {
      src: forestWaterfallImg,
      alt: 'A tranquil forest with a cascading waterfall amidst greenery.',
    },
    lat: 44.5588,
    lon: -80.344,
  },
  {
    id: 'p2',
    title: 'Sahara Desert Dunes',
    image: {
      src: desertDunes,
      alt: 'Golden dunes stretching to the horizon in the Sahara Desert.',
    },
    lat: 25.0,
    lon: 0.0,
  },
  {
    id: 'p3',
    title: 'Himalayan Peaks',
    image: {
      src: majesticMountains,
      alt: 'The sun setting behind snow-capped peaks of majestic mountains.',
    },
    lat: 27.9881,
    lon: 86.925,
  },
  {
    id: 'p4',
    title: 'Caribbean Beach',
    image: {
      src: caribbeanBeachImg,
      alt: 'Pristine white sand and turquoise waters of a Caribbean beach.',
    },
    lat: 18.2208,
    lon: -66.5901,
  },
  {
    id: 'p5',
    title: 'Ancient Grecian Ruins',
    image: {
      src: ruinsImg,
      alt: 'Historic ruins standing tall against the backdrop of the Grecian sky.',
    },
    lat: 37.9715,
    lon: 23.7257,
  },
  {
    id: 'p6',
    title: 'Amazon Rainforest Canopy',
    image: {
      src: rainforestImg,
      alt: 'Lush canopy of a rainforest, teeming with life.',
    },
    lat: -3.4653,
    lon: -62.2159,
  },
  {
    id: 'p7',
    title: 'Northern Lights',
    image: {
      src: northernLightsImg,
      alt: 'Dazzling display of the Northern Lights in a starry sky.',
    },
    lat: 64.9631,
    lon: -19.0208,
  },
  {
    id: 'p8',
    title: 'Japanese Temple',
    image: {
      src: japaneseTempleImg,
      alt: 'Ancient Japanese temple surrounded by autumn foliage.',
    },
    lat: 34.9949,
    lon: 135.785,
  },
  {
    id: 'p9',
    title: 'Great Barrier Reef',
    image: {
      src: greatBarrierReefImg,
      alt: 'Vibrant coral formations of the Great Barrier Reef underwater.',
    },
    lat: -18.2871,
    lon: 147.6992,
  },
  {
    id: 'p10',
    title: 'Parisian Streets',
    image: {
      src: parisianStreetsImg,
      alt: 'Charming streets of Paris with historic buildings and cafes.',
    },
    lat: 48.8566,
    lon: 2.3522,
  },
  {
    id: 'p11',
    title: 'Grand Canyon',
    image: {
      src: grandCanyonImg,
      alt: 'Expansive view of the deep gorges and ridges of the Grand Canyon.',
    },
    lat: 36.1069,
    lon: -112.1129,
  },
  {
    id: 'p12',
    title: 'Venetian Canals',
    image: {
      src: venetianCanalsImg,
      alt: 'Glistening waters of the Venetian canals as gondolas glide by at sunset.',
    },
    lat: 45.4408,
    lon: 12.3155,
  },
  {
    id: 'p13',
    title: 'Taj Mahal',
    image: {
      src: tajMahalImg,
      alt: 'The iconic Taj Mahal reflecting in its surrounding waters during sunrise.',
    },
    lat: 27.1751,
    lon: 78.0421,
  },
  {
    id: 'p14',
    title: 'Kerala Backwaters',
    image: {
      src: keralaBackwatersImg,
      alt: 'Tranquil waters and lush greenery of the Kerala backwaters.',
    },
    lat: 9.4981,
    lon: 76.3388,
  },
  {
    id: 'p15',
    title: 'African Savanna',
    image: {
      src: africanSavannaImg,
      alt: 'Wild animals roaming freely in the vast landscapes of the African savanna.',
    },
    lat: -2.153,
    lon: 34.6857,
  },
  {
    id: 'p16',
    title: 'Victoria Falls ',
    image: {
      src: victoriaFallsImg,
      alt: 'The powerful cascade of Victoria Falls, a natural wonder between Zambia and Zimbabwe.',
    },
    lat: -17.9243,
    lon: 25.8572,
  },
  {
    id: 'p17',
    title: 'Machu Picchu',
    image: {
      src: machuPicchuImg,
      alt: 'The historic Incan citadel of Machu Picchu illuminated by the morning sun.',
    },
    lat: -13.1631,
    lon: -72.545,
  },
  {
    id: 'p18',
    title: 'Amazon River',
    image: {
      src: amazonRiverImg,
      alt: 'Navigating the waters of the Amazon River, surrounded by dense rainforest.',
    },
    lat: -3.4653,
    lon: -58.38,
  },
];
